import { Backdrop, Button, CircularProgress, Grid } from '@mui/material'
import Programa from '../../../components/Programa/Programa'
import PrimeTable from '../../../components/PrimeTable'
import dayjs from 'dayjs'
import { useState } from 'react'
import WeekNavigatorStyled from '../../atendimento/componente/WeekNavigator'
import { MdOutlineDoneOutline } from 'react-icons/md'
import { metodoPrograma } from '../../../components/api'

const AtendimentoPortaria = () => {
  const [dataInicial, setDataInicial] = useState(undefined)
  const [dataFinal, setDataFinal] = useState(undefined)
  const [refresh, setRefresh] = useState(0)
  const [loading, setLoading] = useState(false)

  const marcarCheckIn = (atendimento) => async (e) => {
    e.stopPropagation()

    try {
      setLoading(true)

      const retorno = await metodoPrograma('salvaRegistroCheckIn', {
        idAtendimento: atendimento[0],
        idPaciente: atendimento[3].idPaciente,
      })

      if (retorno) {
        setRefresh((v) => !v)
      }
    } finally {
      setLoading(false)
    }
  }

  const marcarCheckOut = (atendimento) => async (e) => {
    e.stopPropagation()

    try {
      setLoading(true)

      const retorno = await metodoPrograma('salvaRegistroCheckOut', {
        idAtendimento: atendimento[0],
        idPaciente: atendimento[3].idPaciente,
      })

      if (retorno) {
        setRefresh((v) => !v)
      }
    } finally {
      setLoading(false)
    }
  }

  const BotaoCheck = ({ loading, onClick, texto }) => (
    <Button
      size="small"
      variant="outlined"
      sx={{ textTransform: 'none' }}
      startIcon={
        loading ? <CircularProgress size={16} /> : <MdOutlineDoneOutline />
      }
      disabled={loading}
      onClick={onClick}
    >
      {loading ? 'Registrando...' : texto}
    </Button>
  )
  return (
    <Programa codigo="CtrlAtendimentoPortaria" habTrocaLocal={true}>
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress color="inherit" />
          <div style={{ marginTop: 16 }}>Registrando atendimento...</div>
        </Grid>
      </Backdrop>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WeekNavigatorStyled
            onChange={({ start, end }) => {
              setDataInicial(start)
              setDataFinal(end)
              setRefresh((prev) => prev + 1)
            }}
          />
        </Grid>

        <Grid item xs={12}>
          {dataInicial !== undefined && dataFinal !== undefined && (
            <PrimeTable
              codigo="CtrlAtendimentoPortaria"
              parametros={{
                dataInicial: dataInicial
                  ? dayjs(dataInicial).format('YYYY-MM-DD HH:mm:ss')
                  : undefined,
                dataFinal: dataFinal
                  ? dayjs(dataFinal).format('YYYY-MM-DD HH:mm:ss')
                  : undefined,
              }}
              refresh={refresh}
              action="lista"
              habSearch
              rows={10}
              head={['Proposta', 'Paciente', 'Check-in', 'Check-out']}
              colStyle={[
                { width: '5%' },
                { width: '40%' },
                { width: '20%' },
                { width: '25%' },
              ]}
              line={(item) => [
                item[0],
                item?.[3]?.nmPaciente || '',
                item?.[21] ? (
                  dayjs(item[21]).format('DD/MM/YYYY HH:mm')
                ) : (
                  <BotaoCheck
                    loading={loading}
                    texto="Registrar Check-in"
                    onClick={marcarCheckIn(item)}
                  />
                ),
                item?.[22] ? (
                  dayjs(item[22]).format('DD/MM/YYYY HH:mm')
                ) : (
                  <BotaoCheck
                    loading={loading}
                    texto="Registrar Check-out"
                    onClick={marcarCheckOut(item)}
                  />
                ),
              ]}
            />
          )}
        </Grid>
      </Grid>
    </Programa>
  )
}

export default AtendimentoPortaria
